var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPedestrian(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_377_6710)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_377_6710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3.79995C14.99 3.79995 15.8 2.99495 15.8 1.99995C15.8 1.00495 14.99 0.199951 14 0.199951C13.005 0.199951 12.2 1.00495 12.2 1.99995C12.2 2.99495 13.005 3.79995 14 3.79995ZM14.12 9.99995H19V8.19995H15.375L13.375 4.86995C13.08 4.36995 12.535 4.03995 11.915 4.03995C11.745 4.03995 11.58 4.06495 11.425 4.10995L6 5.79995V11H7.8V7.33495L9.905 6.67995L6 22H7.8L10.67 13.89L13 17V22H14.8V15.595L12.31 11.055L13.045 8.18495L14.12 9.99995Z",
    fill: "#66676B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_6710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_377_6710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedestrian);
export default __webpack_public_path__ + "static/media/pedestrian.33c2adfe67013a97a62dee35597a445b.svg";
export { ForwardRef as ReactComponent };